import { CONSTANTS, SimpleModal } from '@livable/saas-react-components';
import {
// Chip,
Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
// import { useTranslation } from 'react-i18next';
// import { billStatuses } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import { useSubmeterBillModalStyles } from './styles';
// import { FileDetails } from './fileDetails';
import { SubmeterBillModalContent } from './content';
export const SubmeterBillModal = observer(_ref => {
  let property = _ref.property,
    billTabStoreObject = _ref.billTabStoreObject,
    submeterFinalStateInfo = _ref.submeterFinalStateInfo,
    isOpen = _ref.isOpen,
    handleChangeIsOpen = _ref.handleChangeIsOpen,
    propertyAddress = _ref.propertyAddress,
    utilityName = _ref.utilityName,
    utilityId = _ref.utilityId,
    cycleName = _ref.cycleName,
    allocationMethod = _ref.allocationMethod,
    isPreviewOnly = _ref.isPreviewOnly,
    propertyId = _ref.propertyId,
    buildingId = _ref.buildingId,
    allocationCycleId = _ref.allocationCycleId,
    billingCycleId = _ref.billingCycleId;
  const classes = useSubmeterBillModalStyles();
  const store = useStore();
  // const { t } = useTranslation();
  // const statuses = billStatuses(t);

  const handleClose = () => {
    store.transaction.setBulkCustomChargeErrorElement([]);
    if (handleChangeIsOpen) {
      handleChangeIsOpen(false);
    } else {
      // setIsOpen(false);
    }
  };
  const defaultTitle = /*#__PURE__*/React.createElement("div", {
    className: classes.modalTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, utilityName, " ", cycleName));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    variant: 'flex',
    title: defaultTitle,
    subTitle: "".concat(propertyAddress, " - Allocated by: ").concat(CONSTANTS.ALLOCATION_METHODS[allocationMethod] || allocationMethod),
    isOpen: isOpen
    // triggerAutosave={applyBillAutosave}
    ,
    handleClose: handleClose,
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement("div", {
    className: classes.modalWrapper
  }, /*#__PURE__*/React.createElement(SubmeterBillModalContent, {
    billTabStoreObject: billTabStoreObject,
    utilityName: utilityName,
    utilityId: utilityId,
    handleClose: handleClose,
    property: property,
    isPreviewOnly: isPreviewOnly,
    submeterFinalStateInfoExt: submeterFinalStateInfo,
    propertyId: propertyId,
    propertyAddress: propertyAddress,
    buildingId: buildingId,
    allocationCycleId: allocationCycleId,
    billingCycleId: billingCycleId
  }))));
});